import * as amplitude from '@amplitude/analytics-browser';

import { SnowplowService } from 'wanderu-service-analytics';

function stationChecked({
    action,
    direction,
    selectedStations,
    selectedStationsBefore,
    totalTrips,
    unSelectedStations,
}) {
    const property = {
        num_trips: totalTrips,
        selected_stations: selectedStations,
        unselected_stations: unSelectedStations,
    };

    SnowplowService.fireStructuredEventWithBatchId({
        action: 'select',
        category: 'react_search',
        label: `stations_${direction}`,
        property,
    });

    if (action !== 'reset') {
        amplitude.track('search_filtered', {
            filter_list_selected_count: selectedStations.length,
            filter_list_total_count: selectedStations.length + unSelectedStations.length,
            filter_type: `${direction}_stations_${action}`,
            results_count_before: totalTrips,
            updated_from: selectedStationsBefore,
            updated_to: selectedStations,
        });
    }
}

function moreButtonClicked(action) {
    SnowplowService.fireStructuredEventWithBatchId({
        action: 'click',
        category: 'react_search',
        label: `stations_${action}`,
    });
}

export default {
    moreButtonClicked,
    stationChecked,
};
